import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        return (
            <div className="table-additional-view">
                <div className="table-additional-view-btns">
                    <div className="table-additional-view-btn-groups">
                        <button
                            className={`${
                                (!this.props.filter || this.props.filter === 'all') && 'active'
                            }`}
                            onClick={() => this.props.chooseFilter('all')}
                        >
                            {t('search.comparison.extraButtons.all')}
                        </button>
                        <button
                            className={`${this.props.filter === 'growth' && 'active'}`}
                            onClick={() => this.props.chooseFilter('growth')}
                        >
                            {t('search.comparison.extraButtons.growth')}
                        </button>
                        <button
                            className={`${this.props.filter === 'decline' && 'active'}`}
                            onClick={() => this.props.chooseFilter('decline')}
                        >
                            {t('search.comparison.extraButtons.decline')}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ExtraButtons);
